import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
  viewers: number;
}
export function UrgencyBanner({
  spots,
  onSale,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        // Aparece sticky cuando la sección de compra está cerca de entrar o ya entró
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const sales = ['1 acceso al sistema de Tarot hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 kit de Tarot reservado hace instantes'];
    let saleTimeout: NodeJS.Timeout;
    const triggerSale = () => {
      const randomTime = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      saleTimeout = setTimeout(() => {
        setRecentSale({
          show: true,
          text: sales[Math.floor(Math.random() * sales.length)]
        });
        onSale();
        setTimeout(() => {
          setRecentSale({
            show: false,
            text: ''
          });
        }, 4000);
        triggerSale();
      }, randomTime);
    };
    triggerSale();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(saleTimeout);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-348" data-mp="2cd9mbs7i6qg6">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 50
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.8
      }} className="fixed bottom-6 left-6 z-[60] bg-zinc-900/90 backdrop-blur-md text-white px-3 py-2 rounded-xl shadow-2xl border border-white/10 flex items-center gap-3 max-w-[280px]" data-id="element-349" data-mp="150r4241prajq">
            <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center text-blue-400 shrink-0 border border-blue-500/30" data-id="element-350" data-mp="siey7eramdyb">
              <ShoppingCart size={16} data-id="element-351" data-mp="xit872cgfxyz" />
            </div>
            <div data-id="element-352" data-mp="joadld2r5yr8">
              <p className="text-[9px] font-black text-blue-400 uppercase tracking-widest leading-none mb-0.5" data-id="element-353" data-mp="jnqw1xh0lcdq">
                Venta Reciente
              </p>
              <p className="font-bold text-xs leading-tight" data-id="element-354" data-mp="9rnt4pec99pq">
                {recentSale.text}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="py-2 fixed top-0 left-0 w-full z-50 shadow-2xl border-b border-white/20 bg-white/10 backdrop-blur-2xl" data-id="element-355" data-mp="pxv30pybciz">
        <div className="max-container px-4 flex flex-wrap justify-center items-center text-xs font-black uppercase tracking-tighter gap-[10px]" data-id="element-356" data-mp="3i9ojd2s7nr2l">
          <div className="flex text-[12px] font-[700] font-sans gap-[8px] flex-row items-center justify-start text-purple-950" data-id="element-357" data-mp="3r9tfggryf31g">
            <span className="relative flex h-2 w-2" data-id="element-358" data-mp="3magqnqhivlw8">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75" data-id="element-359" data-mp="3md30xxvssfi5"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-360" data-mp="3rwzn5nt75s"></span>
            </span>
            <Users size={14} className="text-purple-600" data-id="element-361" data-mp="dv6j42uv5oh2" />
            {viewers} PERSONAS MIRANDO
          </div>
          <div className="flex items-center gap-2 font-[700] text-[12px] text-purple-950" data-id="element-362" data-mp="9ueanbttfnlu">
            <span className="relative flex h-2 w-2" data-id="element-363" data-mp="nsbaqi7hac59">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-364" data-mp="nqrq6feshexo"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-365" data-mp="12wdxz4e3uf9y"></span>
            </span>
            <Ticket size={14} className="text-purple-600" data-id="element-366" data-mp="16x7lhwnmxs2b" />
            CUPOS DISPONIBLES: {spots}
          </div>

          {/* Integrated Notification (When sticky) */}
          <AnimatePresence data-id="element-367" data-mp="1bqsfzeq0s3wr">
            {isSticky && recentSale.show && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="flex items-center gap-2 bg-purple-50 text-purple-900 px-3 py-1.5 rounded-full border border-purple-100 font-bold text-[11px] shadow-sm" data-id="element-368" data-mp="1gn0z137c8h97">
                <ShoppingCart size={14} className="text-purple-600" data-id="element-369" data-mp="xy2oiurq26s9" />
                {recentSale.text}
              </motion.div>}
          </AnimatePresence>
        </div>
      </motion.div>
    </>;
}